/**
 * Section registries for the "Sektionen" dropdown in the navbar (and the same list
 * surfaced on mobile in the burger menu).
 *
 * To add a new page that should show the dropdown:
 *   1. Add an entry below keyed by the page's pathname.
 *   2. Add `id="..."` to each <section> element on that page so the scroll-spy in
 *      the Navbar can observe them.
 *
 * Hardcoded rather than fetched from Strapi - this is presentation logic tightly
 * coupled to the page structure, not CMS content.
 */

export interface PageSection {
  label: string;
  sectionId: string;
}

export const PAGE_SECTIONS: Record<string, PageSection[]> = {
  '/': [
    { label: 'Coaching & Alchemie', sectionId: 'transformationswege' },
    { label: 'Signature Transformationserlebnis', sectionId: 'kamingespraeche' },
    { label: 'Training, Consulting & Leadership Expertise', sectionId: 'business' },
    { label: 'BHS-Modell', sectionId: 'bhs-modell' },
    { label: 'Kundenstimmen', sectionId: 'testimonials' },
    { label: 'Begleitung', sectionId: 'coaching-pakete' },
    { label: 'FAQ', sectionId: 'faq' },
    { label: 'Kontakt', sectionId: 'kontakt' },
  ],
  '/bhs-modell': [
    { label: 'Übersicht', sectionId: 'bhs-uebersicht' },
    { label: 'Das Diagramm', sectionId: 'framework' },
    { label: 'Drei Säulen', sectionId: 'saeulen' },
    { label: 'Integration', sectionId: 'synthese' },
    { label: 'Besondere Merkmale', sectionId: 'auszeichnung' },
    { label: 'Ihr Nutzen', sectionId: 'nutzen' },
    { label: 'Methoden & Werkzeuge', sectionId: 'methoden' },
    { label: 'Termin vereinbaren', sectionId: 'bhs-termin' },
  ],
  '/ueber-mich': [
    { label: 'Einführung', sectionId: 'about-hero' },
    { label: 'Philosophie', sectionId: 'philosophie' },
    { label: 'Mein Ansatz', sectionId: 'mein-ansatz' },
    { label: 'Werte', sectionId: 'werte' },
    { label: 'Werdegang', sectionId: 'werdegang' },
    { label: 'Expertise', sectionId: 'expertise' },
    { label: 'Qualifikationen', sectionId: 'qualifikationen' },
    { label: 'Kontakt', sectionId: 'about-kontakt' },
  ],
};

/**
 * @deprecated Use PAGE_SECTIONS['/'] instead. Kept for any external import that
 * still references the old name; the navbar/burger now read PAGE_SECTIONS directly.
 */
export const HOME_SECTIONS = PAGE_SECTIONS['/'];

/**
 * @deprecated The right-side rail (which used this) was removed.
 */
export const DARK_HOME_SECTIONS = new Set<string>(['kamingespraeche']);
